export default function NotFound() {
  return <div className="p-20 text-center"><h1>404 - Page Not Found</h1></div>;
}